export default __webpack_public_path__ + "static/media/AcesseAgoraBackground2.89ec22a5.png";